import { FC } from "react";

import IMAGES from "../../../../assets/themes/images/images";
import styles from "../login.module.scss";

const VerifyFailure: FC = (): JSX.Element => {
  
  return (
    <>
      <div className={`text-center`}>
        <div className={styles.imgBox}>
          <img src={IMAGES.EmailFailed} alt="email-verified" />
        </div>
        <h3 className="font-weight-semi-bold mb-1 heading3">
          Verification unsuccessful.
        </h3>
        <p className="text-dark">
          Please consult with{" "}
          <a
            className="btn btn-link text-decoration-none"
            href="to:contact@medanta.com"
          >
            contact@medanta.com
          </a>
        </p>
      </div>
    </>
  );
};

export default VerifyFailure;
